import { StorageConfig } from '../../Model/StorageConfig';

export enum EFetchStorageConfigAction {
  FETCH_STORAGE_CONFIGS_PENDING = "FETCH_STORAGE_CONFIGs_PENDING",
  FETCH_STORAGE_CONFIGS_SUCCESS = "FETCH_STORAGE_CONFIGs_SUCCESS",
  FETCH_STORAGE_CONFIGS_ERROR =   "FETCH_STORAGE_CONFIGs_ERROR",
}

export type FetchStorageConfigAction = {
  type: EFetchStorageConfigAction;
  storageConfigs?: StorageConfig[],
  error?: any;
};

export function fetchStorageConfigsPending(): FetchStorageConfigAction {
  return {
    type: EFetchStorageConfigAction.FETCH_STORAGE_CONFIGS_PENDING,
  };
}

export function fetchStorageConfigsSuccess(storageConfigs: StorageConfig[]): FetchStorageConfigAction {
  return {
    type: EFetchStorageConfigAction.FETCH_STORAGE_CONFIGS_SUCCESS,
    storageConfigs: storageConfigs,
  };
}

export function fetchStorageConfigsError(error: any): FetchStorageConfigAction {
  return {
    type: EFetchStorageConfigAction.FETCH_STORAGE_CONFIGS_ERROR,
    error: error,
  };
}
